import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import {
  Table,
  Icon,
  Alert,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  NotificationManager,
  Chip,
  Spinner,
} from "design-react-kit";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import AuthModuleErrorsModal from "../Modals/AuthModuleErrorsModal";
import ConfirmDeleteModal from "../Modals/ConfirmDeleteModal";
import {
  downloadFlow,
  filterHandler,
  showFlowType,
  updateStagedFlowStatus,
} from "../../services/helpers";
import { useSignIn, useSignOut } from "react-auth-kit";
import UserContext from "../../store/user-context";
import StagedFlowStatusEnum from "../../helpers/Enums/StagedFlowStatusEnum";

const AuthModuleInvalidFlowsTable = ({ items, columns, getFlows }) => {
  const [results, setResults] = useState(null);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [authFlowErrorsModalOpen, setAuthFlowErrorsModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteFlowModalOpen, setDeleteFlowModalOpen] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
  }, [items]);

  const authFlowErrorsModalOpenHandler = (flow) => {
    setSelectedFlow(flow);
    setTimeout(() => {
      setAuthFlowErrorsModalOpen(true);
    }, 100);
  };

  const authFlowErrorsModalCloseHandler = () => {
    setAuthFlowErrorsModalOpen(false);
    setSelectedFlow(null);
  };

  const deleteFlow = (stagedFlowId) => {
    updateStagedFlowStatus(
      {
        stagedFlowId,
        status: StagedFlowStatusEnum.Deleted,
      },
      setIsLoading,
      signIn,
      signOut,
      navigate,
      userContext,
      setError,
      getFlows,
    );
  };

  const deleteFlowModalOpenHandler = (flow) => {
    setDeleteFlowModalOpen(true);
    setSelectedFlow(flow);
  };

  const deleteFlowModalCloseHandler = () => {
    setDeleteFlowModalOpen(false);
    setSelectedFlow(null);
  };

  return (
    <Fragment>
      {error !== null && error !== undefined && error.length !== undefined && (
        <Alert color="danger" className="w-50 ml-auto mr-auto">
          {error.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </Alert>
      )}
      {isLoading && (
        <p
          style={{
            height: "50px",
            position: "relative",
            marginBottom: "3rem",
          }}
        >
          <Spinner double active />
        </p>
      )}
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Cerca per nome del flusso"}
            column={"name"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getFlows()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="predispositionDate">
                      {result.predispositionDate}
                    </td>
                    <td className="name">{result.name}</td>
                    <td className="clientName">{result.clientCodeName}</td>
                    <td className="flowType">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="stagedFlowStatusLabel text-center">
                      <span
                        style={{ cursor: "pointer" }}
                        title="Clicca qui per vedere tutti gli errori"
                        onClick={(e) => authFlowErrorsModalOpenHandler(result)}
                      >
                        <Chip
                          color="danger"
                          className="text-nowrap"
                          role="button"
                        >
                          {result.stagedFlowStatusLabel}
                        </Chip>
                      </span>
                    </td>
                    <td className="text-center invalidFlowsDropdown">
                      <UncontrolledDropdown className="table-dropdown">
                        <DropdownToggle>
                          <Icon icon="it-more-actions" fill="#06c" />
                          <Link to={null} className="moreActions">
                            Vedi azioni
                          </Link>
                        </DropdownToggle>
                        <DropdownMenu>
                          <div className="d-flex align-items-center ml-3 mr-2">
                            <Icon icon="it-error" fill="#06c" />
                            <Link
                              to={null}
                              className="trasmetti"
                              onClick={(e) =>
                                authFlowErrorsModalOpenHandler(result)
                              }
                            >
                              Dettaglio errori
                            </Link>
                          </div>
                          <hr />
                          <div
                            className="d-flex align-items-center ml-3"
                            style={{ cursor: "pointer" }}
                          >
                            <Icon icon="it-download" fill="#06c" />
                            <Link
                              to={null}
                              className="download text-nowrap"
                              onClick={(e) =>
                                downloadFlow(
                                  "DownloadFlow",
                                  result.id,
                                  setIsLoading,
                                  signIn,
                                  signOut,
                                  navigate,
                                  userContext,
                                  setError,
                                )
                              }
                            >
                              Scarica flusso (dati)
                            </Link>
                          </div>
                          <div
                            className="d-flex align-items-center ml-3"
                            style={{ cursor: "pointer" }}
                          >
                            <Icon icon="it-download" fill="#06c" />
                            <Link
                              to={null}
                              className="download text-nowrap"
                              onClick={(e) =>
                                downloadFlow(
                                  "DownloadDocuments",
                                  result.id,
                                  setIsLoading,
                                  signIn,
                                  signOut,
                                  navigate,
                                  userContext,
                                  setError,
                                )
                              }
                            >
                              Scarica flusso (allegati)
                            </Link>
                          </div>
                          <hr />
                          <div className="d-flex align-items-center ml-3">
                            <Icon icon="it-delete" fill="#06c" />
                            <Link
                              to={null}
                              className="vediNotifiche"
                              onClick={(e) =>
                                deleteFlowModalOpenHandler(result)
                              }
                            >
                              Rimuovi flusso
                            </Link>
                          </div>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                );
              })}

            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <AuthModuleErrorsModal
          modalOpen={authFlowErrorsModalOpen}
          modalCloseHandler={authFlowErrorsModalCloseHandler}
          selectedFlow={selectedFlow}
          isArchivePage={false}
        />
        <ConfirmDeleteModal
          confirmModalOpen={deleteFlowModalOpen}
          confirmModalCloseHandler={deleteFlowModalCloseHandler}
          flowId={selectedFlow?.id}
          target={selectedFlow?.name}
          error={error}
          isLoading={isLoading}
          text={"Stai per eliminare il flusso"}
          actionHandler={deleteFlow}
          confirmButtonText="Sì, elimina"
        />
      </div>
      <div>
        <NotificationManager
          containerId="table-user-message"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
    </Fragment>
  );
};

export default AuthModuleInvalidFlowsTable;
